
import { Component, Vue, Prop } from 'vue-property-decorator'
import { commonModule, installationsModule } from '@/store/modules/store-accessor'

@Component
export default class DeleteInstallationOfferModal extends Vue {
  @Prop()
  payload!: Record<string, any>;

  isDeletingOffer = false;

  async hideModal() {
    commonModule.hideModal();
  }

  async mounted() {
    commonModule.initSnackbar({});
  }

  async doDeleteOffer() {
    this.isDeletingOffer = true;
    try {
      await installationsModule.deleteInstallationOffer(this.payload.offer);
      this.hideModal();
    } finally {
      this.isDeletingOffer = false;
    }
  }
};
